import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getIsMobile } from 'Store/Screen/selectors';
import { clearContent } from 'Components/PickSkanetrafiken/Redux/actions';
import { createTravelReservation, removeTravelReservation } from 'Store/Order/thunks';
import { fetchLocationPoints, fetchTravelOptions } from 'Components/PickSkanetrafiken/Redux/thunks';
import { getPerformanceStartTime, getPerformanceEndTime } from 'Components/OrderItem/Redux/selectors';
import SkanetrafikenSearch from './SkanetrafikenSearch/SkanetrafikenSearch';
import SkanetrafikenRoutes from './SkanetrafikenRoutes/SkanetrafikenRoutes';
import PickSkanetrafiken from './PickSkanetrafiken';

import { 
  getLocationPoints, 
  getTravelOptions, 
} from 'Components/PickSkanetrafiken/Redux/selectors';

import { 
  getSkanetrafiken, 
  getSelectedSkanetrafiken,
  getIsMaxGoHomeTravels,
  getIsMaxGoThereTravels,
} from 'Store/Order/selectors';

interface IPropsInternal {
  isMobile: boolean;
  isMaxGoHomeTravels: boolean;
  isMaxGoThereTravels: boolean;
  performanceStartTime: Date;
  performanceEndTime: Date;
  numberOfSeatsReservations: boolean;
  skanetrafikenItem: Julius.Website.SkanetrafikenItem;
  locationOptions: Julius.Website.SkanetrafikenPoint[];
  travelOptions: Julius.Website.TravelDataViewModel;
  reservations: Julius.Website.TravelRouteViewModel[];
  fetchLocationPoints: (startsWith: string) => void;
  fetchTravelOptions: (from: string, to: string, startTime: Date, endTime: Date, quantity: number, skanetrafikenID: number) => void;
  createTravelReservation: (request: Julius.Website.TravelRouteViewModel) => void;
  removeTravelReservation: (request: Julius.Website.TravelRouteViewModel) => void;
  clearContent: () => void;
}

type Props = IPropsInternal;

class PickSkanetrafikenContainer extends React.PureComponent<Props> {
  private readonly freeItemID: number = 61;
  private readonly commonItemID: number = 17;

  componentWillUnmount() {
    this.props.clearContent();
  }

  getLocationNames = () => {
    return this.props.locationOptions.reduce((
      options: string[], 
      point: Julius.Website.SkanetrafikenPoint,
    ) => {
      options.push(point.name);
      return options;
    }, []);
  }

  onLocationChange = (value: string) => {
    if (value.length > 1) {
      this.props.fetchLocationPoints(value);
    }
  }

  onLocationSelect = (value: string) => {
    if (!value) {
      return;
    }

    const { skanetrafikenItem, performanceStartTime, performanceEndTime } = this.props;

    this.props.fetchTravelOptions(
      value, skanetrafikenItem.locationName, performanceStartTime, 
      performanceEndTime, skanetrafikenItem.maxNbr, skanetrafikenItem.id,
    );
  }

  onAddTravel = (travel: Julius.Website.TravelRouteViewModel) => {
    this.props.createTravelReservation(travel);
  }

  onRemoveTravel = (travel: Julius.Website.TravelRouteViewModel) => {
    this.props.removeTravelReservation(travel);
  }

  isValidSkanetrafikenItem = () => {
    const { skanetrafikenItem } = this.props;
    return skanetrafikenItem && 
      (skanetrafikenItem.id === this.commonItemID || 
      skanetrafikenItem.id === this.freeItemID);
  }

  render() {

    if (!this.isValidSkanetrafikenItem()) {
      return null;
    }

    const { id, venueName, locationName } = this.props.skanetrafikenItem;
    const { reservations } = this.props;

    return (
      <PickSkanetrafiken 
        venueName={ venueName }
        locationName={ locationName }
        isFreeOfCharge={ id === this.freeItemID }
      >
        <SkanetrafikenSearch 
          locationOptions={ this.getLocationNames() }
          onLocationChange={ this.onLocationChange }
          onLocationSelect={ this.onLocationSelect }
        />
        { this.props.travelOptions &&
          <>
            <SkanetrafikenRoutes 
              type='route-availability'
              isMobile={ this.props.isMobile }
              travelDirection={ 0 }
              isSelectable={ !this.props.isMaxGoThereTravels }
              travelRoutes={ this.props.travelOptions.fromRoutes }
              onSelect={ this.onAddTravel }
            />
            <SkanetrafikenRoutes 
              type='route-availability'
              isMobile={ this.props.isMobile }
              travelDirection={ 1 }
              isSelectable={ !this.props.isMaxGoHomeTravels }
              travelRoutes={ this.props.travelOptions.backRoutes }
              onSelect={ this.onAddTravel }
            />  
          </>
        }
        { reservations && reservations.length > 0 &&
          <SkanetrafikenRoutes
            type='route-reservations' 
            isMobile={ this.props.isMobile }
            travelDirection={ 1 }
            isSelectable={ true }
            travelRoutes={ this.props.reservations }
            onSelect={ this.onRemoveTravel }
          />  
        }
      </PickSkanetrafiken>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isMobile: getIsMobile(state),
    isMaxGoHomeTravels: getIsMaxGoHomeTravels(state),
    isMaxGoThereTravels: getIsMaxGoThereTravels(state),
    performanceStartTime: getPerformanceStartTime(state),
    performanceEndTime: getPerformanceEndTime(state),
    skanetrafikenItem: getSkanetrafiken(state),
    locationOptions: getLocationPoints(state),
    travelOptions: getTravelOptions(state),
    reservations: getSelectedSkanetrafiken(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchLocationPoints,
    fetchTravelOptions,
    createTravelReservation,
    removeTravelReservation,
    clearContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(PickSkanetrafikenContainer);


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/PickSkanetrafikenContainer.tsx